import React, { useState } from 'react'
import { EnrollService } from '../../../jwt/_services/enrollment-service';
import AsyncSelect from "react-select/async";
import { selectedStyles } from "../../../common";


const camelCaseTextConversion = (text) => {
    return text?.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}

const formatOption = (e) => {
    if (!e) return; 
    const address = e?.ADDRESS;
    return address;
};

const SearchPostalCode = ({ handleAddressChange, setField, t }) => {

    let [isSelected, setSelected] = useState(false);
    const [selectedValue, setSelectedValue]  = useState(null)

    const loadOptions = (searchText) => {
        return EnrollService.getPostalCode(searchText).then(response => {
            if (response !== null && response !== undefined) {
                return response.results
            }
        })
    }

    const responseFormatter = (value) => {
        if(value === 'NIL')
            return ''
        else
            return value

    }

    const handleChange = (e) => {
        // send empty field values on clear (backspace or delete key press)
        let selectedOption = {
            "SEARCHVAL": "",
            "BLK_NO": "",
            "ROAD_NAME": "",
            "BUILDING": "",
            "ADDRESS": "",
            "POSTAL": ""
        }

        selectedOption = {...e}
        let country="";
        if(e?.ADDRESS && e?.ADDRESS?.toLowerCase().includes("singapore")) {
            country="SG"
        }
        e = e ? {
            "postalCode": responseFormatter(e?.POSTAL),
            "blockNumber": e.BLK_NO,
            "streetName": responseFormatter(e?.ROAD_NAME),
            "buildingName":  responseFormatter(e?.BUILDING),
            "ADDRESS": e.ADDRESS,
            "countryCode": country,
        } : {
            "postalCode": "",
            "blockNumber": "",
            "streetName": "",
            "buildingName": "",
            "countryCode": "",
            "ADDRESS": "",
        }
        const address = formatOption(e) ? formatOption(e) : "";
        const postalCode = e?.postalCode ? e?.postalCode : "";
        const blockNumber = e?.blockNumber ? e?.blockNumber: "";

        if (selectedOption?.BLK_NO && selectedOption?.ADDRESS?.includes(selectedOption.BLK_NO)) {
            //remove only the block number from the address using regex
            const blockNumberRegex = new RegExp(`\\b${selectedOption.BLK_NO}\\b`, 'i');
            selectedOption.ADDRESS = selectedOption.ADDRESS.replace(blockNumberRegex, '').trim();
        }  

        if (selectedOption?.BUILDING && selectedOption?.ADDRESS?.includes(selectedOption.BUILDING)) {
            selectedOption.ADDRESS = selectedOption.ADDRESS.replace(selectedOption.BUILDING, '').trim();
            setSelectedValue(selectedOption)
        }else{
            setSelectedValue(selectedOption)
        }    
        
        setSelected(true);
        setField("streetandpostal", address);
        if(window.location.pathname === "/profile"){
            setField("blockNumber",blockNumber)
        }

        handleAddressChange(address, postalCode, e);
    }
    const handleInputChange = (inputValue) => {  
        return inputValue.toUpperCase();  
    };
    return (
        <AsyncSelect
            components={{ DropdownIndicator: null, IndicatorSeparator: null }}
            cacheOptions
            // defaultOptions
            name="streetandpostal"
            id='streetandpostal'
            placeholder={t('Enrol_enter_postal_code')}
            value={selectedValue}
            getOptionLabel={(e) => e && formatOption(e)}
            getOptionValue={(e) => e && formatOption(e)}
            loadOptions={loadOptions}
            onInputChange={handleInputChange}
            onChange={handleChange}
            isClearable={true}
            noOptionsMessage={e => e.inputValue ? 'No Results' : null}
            className={"select-form-control select-postal-code " + (isSelected ? 'selected' : '')}
            styles={selectedStyles}
            maxMenuHeight={160}
        />
    )
}

export default SearchPostalCode